import React from 'react';
import { BaseStore } from 'fluxible/addons';
import { IntlProvider } from 'react-intl';
import StockUsageExample from 'contest/components/StockUsageExample';
import Tooltip from '@99designs/react-components/components/Tooltip';
import Icon from '@99designs/react-components/components/Icon';

// Provides register of tooltips for scenarios like Brief,
// where UI is built from a dataset

export default class TooltipStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.tooltips = {};
        this.intlData = {};
    }

    load({ tooltips, intlData }) {
        this.tooltips = tooltips;
        this.intlData = intlData;
        this.emitChange();
    }

    getForKey(key) {
        const data = this.tooltips[key];
        const ContentComponent = this.getContentForKey(key);
        if (!data || !ContentComponent) {
            return null;
        }
        return (
            <IntlProvider {...this.intlData}>
                <Tooltip tooltipElement={<ContentComponent {...data} />}>
                    <Icon variations={['question-mark-2']} />
                </Tooltip>
            </IntlProvider>
        );
    }

    getContentForKey(key) {
        switch (key) {
            case 'stockPreference':
                return StockUsageExample;
            default:
                return null;
        }
    }
}
TooltipStore.storeName = 'TooltipStore';
TooltipStore.handlers = {};



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/TooltipStore.js